import Contract from './Contract';
import abi from '../abi/coinracerNftMintOld.json';

class CoinracerNFTOld extends Contract {
    constructor(options, address) {
        super(options, "CoinracerNFTOld", abi, address);
    }
}

export default CoinracerNFTOld;